import request from './request'

export function adminLogin(payload) {
  return request.post('/admin/auth/login', payload)
}

export function adminMe() {
  return request.get('/admin/auth/me')
}

export function fetchGlobalControls() {
  return request.get('/admin/global-controls')
}

export function updateDepositControl(enabled) {
  return request.put('/admin/global-controls/deposit', { enabled })
}

export function updateQualificationReviewControl(enabled) {
  return request.put('/admin/global-controls/qualification-review', { enabled })
}

export function fetchUsers() {
  return request.get('/admin/users')
}

export function fetchUserDetail(openid) {
  return request.get(`/admin/users/${encodeURIComponent(openid)}`)
}

export function updateUserProfileQualification(openid, payload) {
  return request.put(`/admin/users/${encodeURIComponent(openid)}/profile-qualification`, payload)
}

export function fetchUserProfileChangeLogs(openid) {
  return request.get(`/admin/users/${encodeURIComponent(openid)}/profile-change-logs`)
}

export function setUserBlacklist(openid, blacklisted) {
  return request.post(`/admin/users/${encodeURIComponent(openid)}/blacklist`, { blacklisted })
}

export function deductUserDeposit(openid, amountFen) {
  return request.post(`/admin/users/${encodeURIComponent(openid)}/deposit/deduct`, { amountFen })
}

export function fetchProducts(params = {}) {
  return request.get('/admin/products', { params })
}

export function setProductShelf(id, onShelf) {
  return request.post(`/admin/products/${encodeURIComponent(id)}/shelf`, { onShelf })
}

export function deleteProduct(id) {
  return request.delete(`/admin/products/${encodeURIComponent(id)}`)
}

function isReviewEndpointMissing(error) {
  const message = String((error && error.message) || '').toLowerCase().replace(/\\/g, '/')
  return message.includes('/admin/products/') &&
    message.includes('/review') &&
    (message.includes('no static resource') || message.includes('not found'))
}

export async function reviewProduct(id, approved, comment = '') {
  const encoded = encodeURIComponent(id)
  try {
    return await request.post(`/admin/products/${encoded}/review`, { approved, comment })
  } catch (error) {
    if (!isReviewEndpointMissing(error)) {
      throw error
    }
    return request.post(`/admin/products/review?id=${encoded}`, { approved, comment })
  }
}

export function fetchQualifications() {
  return request.get('/admin/qualifications')
}

export async function fetchQualificationDetail(openid) {
  const encoded = encodeURIComponent(openid)
  try {
    return await request.get(`/admin/qualifications/${encoded}`)
  } catch (error) {
    const status = error && error.response ? error.response.status : 0
    if (status !== 404) {
      throw error
    }
    return request.get(`/admin/qualifications/detail?openid=${encoded}`)
  }
}

export function reviewQualification(payload) {
  return request.post('/admin/qualifications/review', payload)
}

export function fetchBanners() {
  return request.get('/admin/banners')
}

export function createBanner(payload) {
  return request.post('/admin/banners', payload)
}

export function updateBanner(id, payload) {
  return request.put(`/admin/banners/${encodeURIComponent(id)}`, payload)
}

export function deleteBanner(id) {
  return request.delete(`/admin/banners/${encodeURIComponent(id)}`)
}

export function fetchPurchaseDefaultImages() {
  return request.get('/admin/purchase-default-images')
}

export function createPurchaseDefaultImage(payload) {
  return request.post('/admin/purchase-default-images', payload)
}

export function updatePurchaseDefaultImage(id, payload) {
  return request.put(`/admin/purchase-default-images/${encodeURIComponent(id)}`, payload)
}

export function deletePurchaseDefaultImage(id) {
  return request.delete(`/admin/purchase-default-images/${encodeURIComponent(id)}`)
}

export function fetchCustomerServiceQrs() {
  return request.get('/admin/customer-service-qrs')
}

export function fetchVarieties() {
  return request.get('/admin/varieties')
}

export function createVariety(payload) {
  return request.post('/admin/varieties', payload)
}

export function deleteVariety(id) {
  return request.delete(`/admin/varieties/${encodeURIComponent(id)}`)
}

export function fetchRegions() {
  return request.get('/admin/regions')
}

export function createRegionGroup(payload) {
  return request.post('/admin/regions/groups', payload)
}

export function updateRegionGroup(id, payload) {
  return request.put(`/admin/regions/groups/${encodeURIComponent(id)}`, payload)
}

export function createRegionItem(groupId, payload) {
  return request.post(`/admin/regions/groups/${encodeURIComponent(groupId)}/items`, payload)
}

export function updateRegionItem(id, payload) {
  return request.put(`/admin/regions/items/${encodeURIComponent(id)}`, payload)
}

export function setDefaultRegionItem(id) {
  return request.post(`/admin/regions/items/${encodeURIComponent(id)}/default`)
}

export function createCustomerServiceQr(payload) {
  return request.post('/admin/customer-service-qrs', payload)
}

export function updateCustomerServiceQr(id, payload) {
  return request.put(`/admin/customer-service-qrs/${encodeURIComponent(id)}`, payload)
}

export function deleteCustomerServiceQr(id) {
  return request.delete(`/admin/customer-service-qrs/${encodeURIComponent(id)}`)
}

export function uploadAdminImage(file, scene = 'customer-service-qr') {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('scene', scene)
  return request.post('/upload/image', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
